<template>
  <div>
    <div class="update-required-page">

        <div class="content-wrapper">
      <img
          class="logo"
          :src="require('@/assets/img/Acounto_logo.svg')"
          alt="Acounto"
      />
          <h1 class="title">TÖLTSD LE AZ ÚJ ACOUNTO APPOT!</h1>

          <p class="description">
            Platformunkat új technikai alapokra helyeztük.
            <br/>
            <br/>
            Ez nem jelent funkcionális változást, a megszokott rendszer vár az új
            verzióban.
          </p>

          <a
              class="download-button"
              href="https://play.google.com/store/apps/details?id=com.acounto.app.build20260301"
              target="_blank"
              rel="noopener noreferrer"
          >
            Új app letöltése
          </a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateRequired",
};
</script>

<style scoped>
.update-required-page {
  min-height: 100vh;
  background: linear-gradient(to bottom left, #ffffff 0%, #d0d9de 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.content-wrapper {
  width: 100%;
  max-width: 540px;
  text-align: center;
  color: #252734;
}

.logo {
  width: 220px;
  max-width: 80%;
  margin-bottom: 64px;
}

.title {
  font-family: JumperLight, sans-serif;
  font-size: 56px;
  line-height: 1.05;
  margin: 0 0 60px !important;
  letter-spacing: 0.2px;
}

.description {
  font-family: Poppins, sans-serif;
  font-size: 22px !important;
  line-height: 1.45;
  margin: 0 auto 70px !important;
  padding: 0 30px;
  max-width: 520px;
  color: #2e3342;
}

.download-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 520px;
  min-height: 72px;
  padding: 16px 24px;
  border-radius: 999px;
  background: #b2ec5d;
  color: #252734 !important;
  font-family: JumperBold, sans-serif !important;
  font-size: 18px !important;
  text-decoration: none;
  box-shadow: 0 14px 26px rgba(37, 39, 52, 0.18);
}

.download-button:hover,
.download-button:focus,
.download-button:active {
  text-decoration: none;
}

@media (max-width: 768px) {
  .content-wrapper {
    max-width: 100%;
  }

  .logo {
    width: 190px;
  }

  .title {
    font-size: 30px;
    margin-bottom: 28px;
  }

  .description {
    font-size: 15px !important;
    margin-bottom: 48px;
  }

  .download-button {
    min-height: 62px;
    font-size: 24px;
  }
}
</style>
